'use strict';

const libProjectCenterMap = require('./ProjectCenterMap.js');

/**
 * ObservationLocationMap — the read-only Leaflet map for the Observation workspace's Location tab. Unlike the base
 * ProjectCenterMap (a single draggable center-picker), this plots up to TWO fixed markers for one observation:
 *   • Capture location (device GPS / EXIF) — red
 *   • User location (person) — teal
 * with a dashed connector between them and an auto fitBounds "combined" view. Nothing is draggable/clickable (the
 * observation's captured coordinates are historical field data, not editable here). A second instance, LocationViewMap,
 * plots a Location's single point the same way for the Location workspace's Details tab. The workspace calls
 * showForProject() from the Location tab's OnEnter, reading the points from the provider's mapPoints().
 */
class ObservationLocationMap extends libProjectCenterMap
{
	get provider() { return this.pict.providers[(this.options && this.options.ProviderName) || 'ObservationWorkspace']; }
	get mapHostID() { return (this.options && this.options.MapHostID) || 'OW-MapHost'; }

	showForProject()
	{
		const L = this.leafletLib;
		const tmpHost = (typeof document !== 'undefined') ? document.getElementById(this.mapHostID) : null;
		if (!L || !tmpHost || !this.provider) { return; }

		if (this._map) { try { this._map.remove(); } catch (pError) { /* prior map already detached */ } this._map = false; this._marker = false; }

		const tmpPoints = (typeof this.provider.mapPoints === 'function') ? (this.provider.mapPoints() || {}) : {};
		const tmpCapture = tmpPoints.capture || null;
		const tmpUser = tmpPoints.user || null;
		const tmpAny = tmpCapture || tmpUser;
		const tmpCenter = tmpAny ? [ tmpAny.lat, tmpAny.lng ] : [ 39.5, -98.35 ];

		this._map = L.map(tmpHost, { scrollWheelZoom: true }).setView(tmpCenter, tmpAny ? 15 : 4);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(this._map);

		const tmpBounds = [];
		// A point may name itself (the Location workspace's single point is 'Location'); otherwise the observation labels.
		if (tmpCapture) { this._dot(tmpCapture.lat, tmpCapture.lng, '#c0392b', tmpCapture.label || 'Capture — device / EXIF'); tmpBounds.push([ tmpCapture.lat, tmpCapture.lng ]); }
		if (tmpUser) { this._dot(tmpUser.lat, tmpUser.lng, '#2e7d74', tmpUser.label || 'User — person'); tmpBounds.push([ tmpUser.lat, tmpUser.lng ]); }
		if (tmpCapture && tmpUser) { L.polyline([ [ tmpCapture.lat, tmpCapture.lng ], [ tmpUser.lat, tmpUser.lng ] ], { color: '#8894a4', weight: 2, dashArray: '4 5' }).addTo(this._map); }
		if (tmpBounds.length > 1) { this._map.fitBounds(tmpBounds, { padding: [ 45, 45 ], maxZoom: 17 }); }

		setTimeout(() => { if (this._map) { this._map.invalidateSize(); } }, 60);
	}

	/** A fixed, non-interactive colored dot marker with a hover tooltip (no dragging — read-only field data). */
	_dot(pLat, pLng, pColor, pLabel)
	{
		const L = this.leafletLib;
		if (!L || !this._map) { return; }
		L.circleMarker([ pLat, pLng ], { radius: 9, color: '#ffffff', weight: 2, fillColor: pColor, fillOpacity: 0.95, interactive: true })
			.addTo(this._map)
			.bindTooltip(pLabel, { direction: 'top', offset: [ 0, -6 ] });
	}
}

module.exports = ObservationLocationMap;

module.exports.default_configuration = Object.assign({}, libProjectCenterMap.default_configuration,
	{
		ViewIdentifier: 'ObservationLocationMap',
		ProviderName: 'ObservationWorkspace',
		MapHostID: 'OW-MapHost',
		LeafletDestinationAddress: 'OW-MapHost',
	});
